// Vendors
import $ from 'jquery';
import { AJAX_URL } from './config';
import globalLoader from './site/global-loader';

$(document).on('click', 'button.plus, button.minus', function () {
  // Get current quantity values
  const qty = $(this).parent().find('.qty');
  const val = parseFloat(qty.val());
  const max = parseFloat(qty.attr('max'));
  const min = parseFloat(qty.attr('min'));
  const step = parseFloat(qty.attr('step'));

  // Change the value if plus or minus
  if ($(this).is('.plus')) {
    if (max && max <= val) {
      qty.val(max);
      qty.trigger('change');
    } else {
      qty.val(val + step);
      qty.trigger('change');
    }
  } else {
    if (min && min >= val) {
      qty.val(min);
    } else if (val > 1) {
      qty.val(val - step);
      qty.trigger('change');
    }
  }
});

// Fragrance is udpated
$(document).on('change', 'select.row-fragrance', function () {
  const index = $(this).data('index');
  const productID = $(this).val();

  $.ajax({
    type: 'POST',
    url: `${AJAX_URL}post_quick_order_fragrance_update`,
    dataType: 'json',
    encode: true,
    data: { index, productID },
    success: (res) => {
      if (res.data) {
        updateProductType(index, res.data.variations);
        updateProductPrice(index);
        updateProductTotal(index);
      }
    }
  });
});

// Product Type is udpated
$(document).on('change', 'select.row-product-type', function () {
  const index = $(this).data('index');
  const variationID = $(this).val();

  $.ajax({
    type: 'POST',
    url: `${AJAX_URL}post_quick_order_product_type_update`,
    dataType: 'json',
    encode: true,
    data: { index, variationID },
    success: (res) => {
      if (res.data) {
        updateProductPrice(index, res.data.variation);
        updateProductTotal(index);
      }
    }
  });
});

$(document).on('change', 'input.qty', function () {
  const index = $(this).data('index');
  updateProductTotal(index);
});

$(document).on('click', 'button.add-product', function (event) {
  event.preventDefault();
  globalLoader.show();
  const quickOrderRows = $('.cart_item');
  let newIndex = 0;

  quickOrderRows.each(function () {
    const quickOrderRowIndex = $(this).data('index');
    newIndex = quickOrderRowIndex + 1;
  });
  addProductRow(newIndex);
});

$(document).on('click', 'button.add-to-cart', function (event) {
  event.preventDefault();
  globalLoader.show();
  addProductsToCart();
});

const updateProductType = (index, variations) => {
  const productTypeSelect = $('#product-type-' + index);

  if (productTypeSelect.length) {
    productTypeSelect.prop('disabled', false);
    productTypeSelect.empty().append('<option>Select a Product</option>');

    $.each(variations, function (i, variation) {
      productTypeSelect.append(
        $('<option>', {
          value: variation.variation_id,
          text: variation.variation_name
        })
      );
    });
  }
};

const updateProductPrice = (index, variation) => {
  const quickOrderRowClass = '.quick-order-row-' + index;
  const variationPriceCell = $(quickOrderRowClass + ' .product-price');
  const productQuantityParent = $(
    quickOrderRowClass + ' .product-quantity .quantity'
  );

  if (variationPriceCell.length && variation) {
    variationPriceCell.data('price', variation.price);
    variationPriceCell.html(variation.price_html);
    productQuantityParent.children().prop('disabled', false);
  } else {
    variationPriceCell.html('0.00');
    variationPriceCell.data('price', 0);
  }
};

const updateProductTotal = (index) => {
  const quickOrderRowClass = '.quick-order-row-' + index;
  const productQuantity = $('#quantity-' + index).val();
  const variationPrice = $(quickOrderRowClass + ' .product-price').data(
    'price'
  );
  const subTotal = productQuantity * variationPrice;

  // Display Subtotal
  $('.product-subtotal-double-' + index).text(
    subTotal.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
  );
  $(
    quickOrderRowClass + ' .product-subtotal .woocommerce-Price-amount'
  ).removeClass('u--display-none');
  updateCartTotal();
};

const updateCartTotal = () => {
  const quickOrderRows = $('.cart_item');
  let cartTotal = 0;

  quickOrderRows.each(function () {
    const quickOrderRowIndex = $(this).data('index');
    const quickOrderRowSubtotal = $(
      '.product-subtotal-double-' + quickOrderRowIndex
    );

    cartTotal = parseFloat(quickOrderRowSubtotal.text()) + cartTotal;
  });

  $('.order-total').text(
    cartTotal.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
  );
};

const addProductRow = (index) => {
  $.ajax({
    type: 'POST',
    url: `${AJAX_URL}post_add_quick_order_product_row`,
    dataType: 'json',
    encode: true,
    data: { index: index },
    success: (res) => {
      if (res.data) {
        $('table.quick_order_table')
          .find('tbody')
          .append(res.data.table_row_html);

        globalLoader.hide();
      }
    }
  });
};

const addProductsToCart = () => {
  const quickOrderRows = $('.cart_item');
  let products = [];

  quickOrderRows.each(function () {
    const quickOrderRowIndex = $(this).data('index');

    products.push({
      productID: $('#fragrance-' + quickOrderRowIndex).val(),
      variationID: $('#product-type-' + quickOrderRowIndex).val(),
      quantity: $('#quantity-' + quickOrderRowIndex).val()
    });
  });

  $.ajax({
    type: 'POST',
    url: `${AJAX_URL}post_quick_order_add_products_to_cart`,
    dataType: 'json',
    encode: true,
    data: { products: products },
    success: (res) => {
      if (res.data) {
        window.location.replace(res.data.redirect_url);
      }
    }
  });
};
